import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {CrudConfig, CrudInteractionService, CrudService} from '@ngx-ivengi/crud';
import {Exportation} from './exportation.model';

@Injectable()
export class ExportationService extends CrudService<Exportation> {
  public entityType = Exportation;
  public entityName = 'exportation';

  constructor(
    protected crudConfig: CrudConfig,
    protected http: HttpClient,
    protected interactionService: CrudInteractionService,
  ) {
    super(crudConfig, http, interactionService);
  }
}






// WEBPACK FOOTER //
// /var/jenkins_home/workspace/brands-compart-portal-frontend/checkout/src/app/components/exportation/exportation.service.ts